import { createFileRoute } from "@tanstack/react-router";
import { actions } from "../../lib/actions.ts";
import { PlaybooksScreen } from "../../screens/act/PlaybooksScreen.tsx";

/** `/insights/playbooks`: what the company does when something happens, Adea's proposals on top. */
export const Route = createFileRoute("/_app/insights/playbooks")({
  loader: ({ context }) => context.queryClient.prefetchQuery(actions.queryOptions("playbooks.list", {})),
  component: PlaybooksScreen,
});
